import { cx } from '@linaria/core';
import { memo, useCallback } from 'react';
import { openMenuDialog } from '../../../../actions/menu';
import { AppStateType, SettingsType } from '../../../../constants/enums';
import { getRecommendationPercentage } from '../../../../mfcLogic/recommendation';
import { getAnimationsEnabledfromUeopt } from '../../../../mfcLogic/settings';
import { TransitionTypes } from '../../../../state';
import { openRoom } from '../../../../state/state.rooms';
import { trackAnalyticsEvent } from '../../../../utilities/analytics';
import { useAppStateSelector } from '../../../Hooks/useAppState';
import { useModelColor } from '../../../Hooks/useModelColor';
import { useSettingSelector } from '../../../Hooks/useSettings';
import { useUserSelector } from '../../../Hooks/useUser';
import PercentageBar from '../../../common/PercentageBar';
import Header from '../../Profile/Header';
import { modelNameStyles } from '../shared';
import "./List.linaria.module.css!=!./List?./List.linaria.module.css?css=H4sIAAAAAAAAA2WRUW+zIBSG7/crevMl2wUGrNbKfgxhgkpFsAcKOrL/vnSddu13Q/Lmed7AOWTcjywsjFh3tnlIUQnfU4Lxv/evl+wKT/sNjnxG/wu1Y8TPUQWdhHKT5gtttZxXzIEFCI2cH1O6OkgokI1X1lCwcWvMbPioTPh8TLdGBzZSst19Yl4PEuvUXMBZoJNVxktY+eAYKcM5Rkg2SGi1jbRXQkizGu7MiM6dEiF5OXu0aVJrNTnlVlHmTBOoe596qbre0xpP25B6YKRY8mq5PMU0cSGU6ZCWraflvcFHRjp/WnT7MxclO7zjF29X3ilGRhCFLNPIoVOGXukO/+FKTG1XrHgj/Z75uli8e0y/HvJ2ouT+jkoz0rrchpgaqy3QwOEVIScbawSHBV238rbaLbCDiDAPSUvvJSA38UaZjuIM43p/lONqNkdGqip25eEpptYaj5z6lBRnB/jTcIwYQ9pj9xRvjXjbeoHvK9gzgk17KaanmLQyEv1+E8nycm3EgtWnSbmQogWBPkDygf6ciGv9/vXyDSWJpC0PAwAA"
const rootStyles = "atm_vy_1osqo2v atm_j3_1osqo2v";
const containerStyles = "atm_9s_1txwivl atm_ar_vrvcex atm_ax_kb7nvz atm_9j_tlke0l";
const youMayLikeContainerStyles = "atm_vy_1osqo2v atm_ks_15vqwwr atm_sq_1l2sidv atm_e2_l1r9ht atm_lk_14y27yu";
const avatarPreviewContainerStyles = "atm_am_1gtjylf atm_gi_1mrd4e5";
const topicStyles = "atm_gi_idpfg4 atm_h3_t94yts atm_7l_1fs2ovw atm_fr_6dwrxk atm_c8_177wg56 atm_cs_1nn1f8g atm_g3_10nfu4p atm_w4_9jpisv";
interface ListProps {
  id: number;
  recommendation: number;
  inRoomOrProfile?: boolean;
}
const List = (props: ListProps) => {
  const {
    id,
    recommendation,
    inRoomOrProfile
  } = props;
  const isMobile = useAppStateSelector(AppStateType.APP, 'isMobile');
  const matchPercentage: number = getRecommendationPercentage(recommendation);
  const [animatePreviews] = useSettingSelector(SettingsType.DEFAULT, 'animatePreviews');
  const [display] = useSettingSelector(SettingsType.DEFAULT, 'display');
  const staticImage = !getAnimationsEnabledfromUeopt(animatePreviews);
  const isBroadcasting = useUserSelector(id, 'isBroadcasting');
  const isOffline = useUserSelector(id, 'isOffline');
  const is16x9 = useUserSelector(id, 'is16x9');
  const hasShare = useUserSelector(id, 'hasShare');
  const color = useUserSelector(id, 'color');
  const topic = useUserSelector(id, 'topic');
  const name = useUserSelector(id, 'name');
  const slug = useUserSelector(id, 'slug');
  const modelColor = useModelColor(color);
  const onClickOpenMenu = useCallback(() => {
    openMenuDialog(slug, {
      hideNextPrev: true,
      // transitionSource: TransitionTypes.MENU,
      transitionSource: inRoomOrProfile ? TransitionTypes.ROOM : TransitionTypes.MENU
    });
  }, [slug, inRoomOrProfile]);
  const onClickOpenRoom = useCallback(() => {
    trackAnalyticsEvent({
      action: `ModelsYouMayLike__ClickThrough`
    });
    openRoom(slug, {
      // transitionSource: TransitionTypes.MENU,
      transitionSource: inRoomOrProfile ? TransitionTypes.ROOM : TransitionTypes.MENU
    });
  }, [slug, inRoomOrProfile]);
  if (!name) {
    return null;
  }
  return <section key={id} data-testid="ModelsYouMayLike__EmbeddedRecommendationRow" className={rootStyles}>
            <article className={containerStyles}>
                <div className={avatarPreviewContainerStyles}>
                    <Header onClickAvatar={onClickOpenMenu} onClickPreview={onClickOpenRoom} broadcasting={isBroadcasting} displayMode={display} disableBadge={true} staticImage={staticImage} isMobile={isMobile} offline={isOffline} showInfo={false} hasShare={hasShare} is16x9={is16x9} small={true} slug={slug} name={name} id={id} />
                </div>
                <div onClick={onClickOpenRoom} data-testid="ModelsYouMayLike__Recommendation_Details" className={youMayLikeContainerStyles}>
                    <span style={{
          color: modelColor
        }} className={modelNameStyles}>
                        {name}
                    </span>
                    <PercentageBar percentage={matchPercentage} color={modelColor} />
                    <p className={cx('mfc-age-gate', topicStyles)}>{topic}</p>
                </div>
            </article>
        </section>;
};
export default memo(List);